// extracted by mini-css-extract-plugin
module.exports = {"animate":"styles_animate__dkUIS","show":"styles_show__HLq4b"};